import { CollectedItemDetails, MagicCard } from "@apiserver-rest/ponder-data-client-base";
import { FilteredPreviewItem } from "@ponder-shared/tools/filter/filtered-preview-item";
import { FilterType, PreviewItemFilterOption } from "@ponder-shared/tools/filter/preview-item-filter-option";

export class MagicCardFilterText extends PreviewItemFilterOption {
    private currentChoice?: string;

    constructor() {
        super("Text", FilterType.Text, "Text ... \"counter target\"", "", "");
    }

    public prepare(): void {
        // ... nothing ...
    }

    public track(magicCard: MagicCard, collectedInfo: CollectedItemDetails | undefined): void {
        // ... nothing ...
    }

    public updateSelection(selection: string, page: string): boolean {
        if (this.currentChoice === selection) {
            return false;
        }

        this.currentChoice = selection?.toLocaleLowerCase();
        this.setStoredFilter(this.currentChoice, page);
        this.wasUpdated = true;
        
        return true;
    }

    public getFilters(): Map<string, number | undefined> {
        throw new Error("Shouldn't be here (getFilters on text");
    }

    public isValid(magicCard: MagicCard, collectedInfo: CollectedItemDetails | undefined): boolean {
        if (!this.currentChoice) {
            return true;
        }

        for (let i = 0; i < magicCard.faces!.length; ++i) {
            let face = magicCard.faces![i]!;

            if ((face.oracleText && face.oracleText.toLowerCase().indexOf(this.currentChoice!) >= 0) ||
                (face.flavorText && face.flavorText.toLowerCase().indexOf(this.currentChoice) >= 0) ||
                (face.typeLine && face.typeLine.toLowerCase().indexOf(this.currentChoice) >= 0) ||
                (face.localizedText && face.localizedText.toLowerCase().indexOf(this.currentChoice) >= 0) ||
                (face.localizedTypeLine && face.localizedTypeLine.toLowerCase().indexOf(this.currentChoice) >= 0)) {
                return true;
            }
        }

        if (magicCard.setIndex!.toLowerCase().indexOf(this.currentChoice!) >= 0 ||
            magicCard.set.code!.toLowerCase().indexOf(this.currentChoice!) >= 0 ||
            magicCard.set.name!.toLowerCase().indexOf(this.currentChoice!) >= 0) {
            return true;
        }

        return false;
    }

    public sort(previewItems: FilteredPreviewItem[]): void {
        // ... nothing ...
    }

    public override setUserInfo(isCollection: boolean, isAuthed: boolean): void {
        // ... nothing ...
    }
}